import React from 'react';

// local imports
import * as S from './styles';

export type InformationBoxProps = {
  text: string;
  className?: string;
  iconOverride?: React.ReactNode;
  children?: React.ReactNode;
};

export const InformationBox = ({
  text,
  className,
  iconOverride,
  children,
}: InformationBoxProps) => (
  <S.Wrapper className={className}>
    <S.IconWrapper>{iconOverride ? iconOverride : <S.Icon />}</S.IconWrapper>
    <div>
      {text}
      {children ? children : null}
    </div>
  </S.Wrapper>
);

export default InformationBox;
